export const types = {
    vnpay: "VNPay",
    momo: "Momo",
    napas: "Napas",
}
